import { useEffect } from 'react';

const useKeydown = (key, callback) => {
  useEffect(() => {
    const handleKeyDown = (event) => {
      const { code } = event;

      if (code === key) {
        event.preventDefault();
        callback(event);
      }
    };

    window.addEventListener('keydown', handleKeyDown);

    return () => {
      window.removeEventListener('keydown', handleKeyDown);
    };
  }, [callback]);
};

export default useKeydown;
